"use client";
import Image from "next/image";
import React from "react";

export const AuthLogo = () => {
  return (
    <div className="flex w-full justify-center items-center z-10 pb-5">
      <Image src="/images/br-logo.png" alt="br-logo" width={100} height={100} className="" />
    </div>
  );
};
